{
  "addresses": [
    {
      "street": "Snorregatan 1",
      "zip": "442 35",
      "city": "Kungälv"
    },
    {
      "street": "Ragnhildsgatan 2",
      "zip": "442 35",
      "city": "Kungälv"
    },
    {
      "street": "Fredkullagatan 3",
      "zip": "442 35",
      "city": "Kungälv"
    },
    {
      "street": "Kolonigatan 4",
      "zip": "440 30",
      "city": "Marstrand"
    }
  ]
}